module.exports = __webpack_public_path__ + "img/filters.4d6ba240.svg";